import {
	FETCH_AVAILABILITIES_STATUS,
	useSDPTravelDatesAvailability,
} from "./useSDPTravelDatesAvailability";
import { useStopoverTravelDatesAvailability } from "./useStopoverTravelDatesAvailability";
import { useHotelonlyTravelDatesAvailability } from "./useHotelonlyTravelDatesAvailability";
import { TravelMode } from "../types";

type DateLike = string | Date;

type AvailabilityItem = {
	duration?: number;
	ed?: string;
};

type AvailabilitiesByDate = Record<string, AvailabilityItem[]>;

type UseTravelDatesAvailabilityParams = {
	travelMode: TravelMode;
	uri?: string;
	departureCity?: string;
	destinationResort?: string;
	departureDate?: DateLike;
	returnDate?: DateLike;
	availabilities?: AvailabilitiesByDate;
	fetchAvailability: (uri: string) => unknown;
	resetAvailability: () => void;
	clearDates?: () => void;
};

export const useTravelDatesAvailability = ({
	travelMode,
	uri,
	departureCity,
	destinationResort,
	departureDate,
	returnDate,
	availabilities,
	fetchAvailability,
	resetAvailability,
	clearDates,
}: UseTravelDatesAvailabilityParams) => {
	const sdpAvailability = useSDPTravelDatesAvailability({
		travelMode,
		uri,
		departureCity,
		destinationResort,
		departureDate,
		returnDate,
		availabilities,
		fetchAvailability,
		resetAvailability,
		clearDates,
	});

	const stopoverAvailability = useStopoverTravelDatesAvailability({
		departureCity,
		destinationResort,
		departureDate,
		returnDate,
	});

	const hotelonlyAvailability = useHotelonlyTravelDatesAvailability({
		destinationResort,
		departureDate,
		returnDate,
	});

	if (travelMode === "sdp") {
		return sdpAvailability;
	}

	if (travelMode === "stopover") {
		return stopoverAvailability;
	}

	if (travelMode === "hotelonly") {
		return hotelonlyAvailability;
	}

	return {
		minDate: undefined,
		maxDate: undefined,
		availabilitiesStatus: FETCH_AVAILABILITIES_STATUS.LOADING,
		isDateDisabled: () => true,
	};
};
